import { useMemo } from 'react';
import { isProfile } from './isProfile';
import { SearchResultItem } from './types';

export const useProfilesOnly = (results: SearchResultItem[]) =>
  useMemo(() => results.filter(isProfile), [results]);
